import { useMsal } from '@azure/msal-react';
import { useOTPAuth } from '../auth/providers/OTPAuthProvider';

export const useAuth = () => {
  const { instance, accounts, inProgress } = useMsal();
  const { isAuthenticated: isOTPAuthenticated, user: otpUser, loading: otpLoading } = useOTPAuth();
  
  const isMsalAuthenticated = accounts.length > 0;
  const msalUser = accounts[0] || null;
  
  // Check both auth methods
  const isAuthenticated = isMsalAuthenticated || isOTPAuthenticated;
  
  // Return the appropriate user based on which auth method is active
  let user = null;
  if (otpUser) {
    user = {
      email: otpUser.email,
      name: otpUser.name || otpUser.email,
      id: otpUser.id,
    };
  } else if (msalUser) {
    user = {
      email: msalUser.username,
      name: msalUser.name || msalUser.username,
      id: msalUser.localAccountId || msalUser.homeAccountId,
    };
  }
  
  return {
    isAuthenticated,
    user,
    loading: inProgress !== 'none' || otpLoading,
  };
};